// extracted by mini-css-extract-plugin
module.exports = {"upload":"AddCompanyForm_upload__3utzH","error":"AddCompanyForm_error__9YkxE","secondaryButton":"AddCompanyForm_secondaryButton__3vYLg"};